const loanPurposeDefault = [
  { title: 'loan_purpose.field.financing_big_purchase', type: 'FINANCING_BIG_PURCHASE', intl: true },
  { title: 'loan_purpose.field.daily_expenditure', type: 'DAILY_EXPENDITURE', intl: true },
  { title: 'loan_purpose.field.education_training', type: 'EDUCATION_TRAINING', intl: true },
  { title: 'loan_purpose.field.traveling_vacation', type: 'TRAVELING_VACATION', intl: true },
  { title: 'loan_purpose.field.refinancing_other_loans', type: 'REFINANCING_OTHER_LOANS', intl: true },
  { title: 'loan_purpose.field.home_repair_construction', type: 'HOME_REPAIR_CONSTRUCTION', intl: true },
  { title: 'loan_purpose.field.car_repair_or_purchase', type: 'CAR_REPAIR_OR_PURCHASE', intl: true },
  { title: 'loan_purpose.field.medical_expences', type: 'MEDICAL_EXPENCES', intl: true },
  { title: 'loan_purpose.field.business_starting_business', type: 'BUSINESS_STARTING_BUSINESS', intl: true },
  { title: 'loan_purpose.field.other', type: 'OTHER', intl: true },
];

const loanPurposePL = [
  { title: 'loan_purpose.field.financing_other_loans', type: 'FINANCING_OTHER_LOANS', intl: true },
  { title: 'loan_purpose.field.daily_expenditure', type: 'DAILY_EXPENDITURE', intl: true },
  { title: 'loan_purpose.field.traveling_vacation', type: 'TRAVELING_VACATION', intl: true },
  { title: 'loan_purpose.field.education_training', type: 'EDUCATION_TRAINING', intl: true },
  { title: 'loan_purpose.field.car_repair_or_purchase', type: 'CAR_REPAIR_OR_PURCHASE', intl: true },
  { title: 'loan_purpose.field.financing_big_purchase', type: 'FINANCING_BIG_PURCHASE', intl: true },
  { title: 'loan_purpose.field.home_repair_construction', type: 'HOME_REPAIR_CONSTRUCTION', intl: true },
  { title: 'loan_purpose.field.business', type: 'BUSINESS', intl: true },
  { title: 'loan_purpose.field.medical_expences', type: 'MEDICAL_EXPENCES', intl: true },
  { title: 'loan_purpose.field.other', type: 'OTHER', intl: true },
  { title: 'loan_purpose.field.third_party', type: 'THIRD_PARTY', intl: true },
];

const loanPurposeEE = [
  { title: 'loan_purpose.field.home', type: 'HOME_REPAIR_CONSTRUCTION', intl: true },
  { title: 'loan_purpose.field.car', type: 'CAR_REPAIR_OR_PURCHASE', intl: true },
  { title: 'loan_purpose.field.travel', type: 'TRAVELING_VACATION', intl: true },
  { title: 'loan_purpose.field.medical', type: 'MEDICAL_EXPENCES', intl: true },
  { title: 'loan_purpose.field.other', type: 'OTHER', intl: true },
];

const loanPurposeLV = [
  { title: 'loan_purpose.field.home', type: 'HOME_REPAIR_CONSTRUCTION', intl: true },
  { title: 'loan_purpose.field.car', type: 'CAR_REPAIR_OR_PURCHASE', intl: true },
  { title: 'loan_purpose.field.travel', type: 'TRAVELING_VACATION', intl: true },
  { title: 'loan_purpose.field.medical', type: 'MEDICAL_EXPENCES', intl: true },
  { title: 'loan_purpose.field.other', type: 'OTHER', intl: true },
];

const loanPurposeMX = [
  { title: 'loan_purpose.field.financing_other_loans', type: 'FINANCING_OTHER_LOANS', intl: true },
  { title: 'loan_purpose.field.financing_other_small_loans', type: 'FINANCING_OTHER_LOANS_LESS_THAN_30', intl: true },
  { title: 'loan_purpose.field.travel', type: 'TRAVELING_VACATION', intl: true },
  { title: 'loan_purpose.field.education_training', type: 'EDUCATION_TRAINING', intl: true },
  { title: 'loan_purpose.field.financing_big_purchase', type: 'FINANCING_BIG_PURCHASE', intl: true },
  { title: 'loan_purpose.field.business', type: 'BUSINESS', intl: true },
  { title: 'loan_purpose.field.medical', type: 'MEDICAL_EXPENCES', intl: true },
  { title: 'loan_purpose.field.entertainment', type: 'ENTERTAINMENT', intl: true },
  { title: 'loan_purpose.field.car_improvement', type: 'CAR_IMPROVEMENT', intl: true },
  { title: 'loan_purpose.field.home_improvement', type: 'HOME_IMPROVEMENT', intl: true },
  { title: 'loan_purpose.field.other', type: 'OTHER', intl: true },
];

let data = [];
switch (COUNTRY) {
  case 'PL':
    data = data.concat(loanPurposePL);
    break;
  case 'EE':
    data = data.concat(loanPurposeEE);
    break;
  case 'LV':
    data = data.concat(loanPurposeLV);
    break;
  case 'MX':
    data = data.concat(loanPurposeMX);
    break;
  default:
    data = data.concat(loanPurposeDefault);
}

const loanPurpose = data;
export default loanPurpose;
